import React from 'react';
import { FiMail, FiMapPin } from 'react-icons/fi';
import SEO from '../components/SEO/SEO';

const CONTACT_EMAIL = 'liaqatapril@gmail.com';

const Contact: React.FC = () => {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'ContactPage',
    name: 'Contact travelbaba786',
    url: 'https://travelbaba786.com/contact',
    description: 'Contact travelbaba786 for questions about visa information, broken links, privacy, or business enquiries.',
    mainEntity: {
      '@type': 'Organization',
      name: 'travelbaba786',
      url: 'https://travelbaba786.com',
      email: CONTACT_EMAIL,
      contactPoint: {
        '@type': 'ContactPoint',
        email: CONTACT_EMAIL,
        contactType: 'Customer Service',
        availableLanguage: ['English'],
      },
    },
  };

  return (
    <>
      <SEO
        title="Contact travelbaba786"
        description="Contact travelbaba786 at liaqatapril@gmail.com for visa directory questions, broken links, privacy requests, or business enquiries."
        keywords="contact travelbaba786, visa help, travelbaba786 email"
        url="https://travelbaba786.com/contact"
        structuredData={structuredData}
      />
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-gray-900 dark:text-white">
            Contact Us
          </h1>
          <p className="text-lg text-gray-600 dark:text-gray-300">
            We are an independent travel information directory. Reach us anytime at the official email below.
          </p>
        </div>

        <div className="bg-white dark:bg-slate-800 rounded-2xl border border-gray-200 dark:border-gray-700 p-8 space-y-8">
          <div className="flex items-start gap-4">
            <div className="p-3 rounded-xl bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400">
              <FiMail className="w-6 h-6" />
            </div>
            <div>
              <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">Email</h2>
              <a
                href={`mailto:${CONTACT_EMAIL}`}
                className="text-blue-600 dark:text-blue-400 font-semibold break-all"
              >
                {CONTACT_EMAIL}
              </a>
              <p className="text-sm text-gray-500 dark:text-gray-400 mt-2">
                Use this email for broken government links, privacy requests, content corrections, and general questions.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-4">
            <div className="p-3 rounded-xl bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400">
              <FiMapPin className="w-6 h-6" />
            </div>
            <div>
              <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">Website</h2>
              <p className="text-gray-700 dark:text-gray-300">https://travelbaba786.com</p>
            </div>
          </div>
        </div>

        <p className="text-sm text-gray-500 dark:text-gray-400 mt-8 text-center">
          We are not a government agency and do not process visa applications. Always apply through official government portals.
        </p>
      </div>
    </>
  );
};

export default Contact;
